<script lang="ts">
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import Dropdown from '$shared/atoms/Dropdown/Dropdown.svelte';
  import { schemaData } from '$shared/lib/data/SchemaData';
  import { SchemaType } from '$provider/lib/apis/models/SchemaType';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  const List = schemaData.getSchemaAsCommonList(SchemaType.InsuranceCoverageType);

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let coverageType: string | undefined;
  let coverageTypeLabel: string | undefined = $state();

  onMount(() => {
    coverageType = alert?.props?.coverageType;
    coverageTypeLabel = List?.find((item: any) => item.id === coverageType)?.label || '';
  });

  const onClickCoverageType = (detail: CommonList): void => {
    coverageType = detail.id;
    coverageTypeLabel = detail.label;

    onevent?.({ type: 'change-coverageType', data: { key: alert.key, type: detail.id } });
  };
</script>

<AlertView
  type={ListAlertType.InsuranceCoverageTypeChange}
  key={Label.ChangeTo}
  icon="icon-corner-down-right"
>
  {#snippet value()}
    <div class="coverage-type">
      <div class="input-wrap">
        <Dropdown
          islarge
          maxWidth
          name="coverageType"
          list={List}
          label={coverageTypeLabel}
          onchange={onClickCoverageType}
        />
      </div>
    </div>
  {/snippet}
</AlertView>

<style>
  .coverage-type {
    width: 400px;
    padding: 4px 16px;
  }
</style>
